import { useEffect, useState } from 'react';

const useMouseDown = (
  callback?: (...e) => any,
  interval?: number,
  thresholdMsec = 250
): [() => void, () => void, boolean, boolean] => {
  const [isStartingTimer, setIsStartingTimerTimer] = useState(false);
  const [isRunning, setIsRunning] = useState(false);

  // Set isRunning=true in thresholdMsec msec
  // when isStartingTimer is changed to true
  useEffect(() => {
    if (!isStartingTimer) {
      return;
    }

    const timeout = setTimeout(() => {
      setIsRunning(true);
    }, thresholdMsec);

    return () => {
      clearTimeout(timeout);
    };
  }, [isStartingTimer, interval, thresholdMsec]);

  // call callback once every "interval" msec if isRunning is true
  useEffect(() => {
    if (!isRunning || !callback) {
      return;
    }

    callback();
    const interval1 = setInterval(callback, interval);

    return () => {
      clearInterval(interval1);
    };
  }, [isRunning, interval, callback]);

  const startTimer = () => {
    if (callback && interval) {
      setIsStartingTimerTimer(true);
    }
  };

  const stopTimer = () => {
    if (callback && interval) {
      setIsRunning(false);
      setIsStartingTimerTimer(false);
    }
  };

  return [startTimer, stopTimer, isStartingTimer, isRunning];
};

export default useMouseDown;
